<div class="ai-assistant-drawer__history-panel" *transloco="let t; prefix: 'ai-assistant'">
  <div class="ai-assistant-drawer__history-header">
    <h3 class="ai-assistant-drawer__history-title">{{ t('chat-history') }}</h3>
    <xi-icon-button
      icon="cancel"
      iconSize="small"
      color="orca"
      (onClick)="close()"
    ></xi-icon-button>
  </div>
  <div class="ai-assistant-drawer__history-filter">
    <xi-toggle-switch
      color="CX"
      [isToggled]="filterByDataSource()"
      [label]="t('filter-by-data-source')"
      (onToggle)="onToggleFilter()"
    ></xi-toggle-switch>
  </div>
  <div class="ai-assistant-drawer__history-list">
    @for (session of sessions(); track session.id) {
      <div
        class="ai-assistant-drawer__history-item"
        [class.ai-assistant-drawer__history-item--active]="currentSessionId() === session.id"
        (click)="onHistoryItemClick(session, $event)"
      >
        @if (editingSessionId() === session.id) {
          <input
            class="ai-assistant-drawer__history-item-input"
            [value]="editingSessionName()"
            (input)="updateEditingSessionName($event)"
            (keydown)="onRenameKeydown($event, session)"
            (blur)="onRenameBlur(session)"
            autocomplete="off"
          />
        } @else {
          <span class="ai-assistant-drawer__history-item-name">{{
            session.name || t('new-chat')
          }}</span>
          <button
            type="button"
            class="ai-assistant-drawer__history-item-menu"
            [matMenuTriggerFor]="historySessionMenu"
            (click)="openHistorySessionMenu(session, $event)"
            [attr.aria-label]="t('session-actions')"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        }
      </div>
    }
    @if (sessions().length === 0) {
      <p class="ai-assistant-drawer__no-history">{{ t('no-history') }}</p>
    }
  </div>
</div>

<mat-menu #historySessionMenu="matMenu" (closed)="clearActiveHistorySession()">
  <button mat-menu-item type="button" (click)="startRenameSession()">
    <mat-icon>edit</mat-icon>
    {{ t('rename-session') }}
  </button>
  <button mat-menu-item type="button" (click)="deleteActiveChatSession($event)">
    <mat-icon>delete</mat-icon>
    {{ t('delete-session') }}
  </button>
</mat-menu>
